import { concat, filter, flatten, groupBy, isEmpty, lensPath, map, pathOr, pipe, prop, reduce, set, values, equals, not, includes } from 'ramda';
import { compose } from 'recompose';
import { APIDispatcher, BaseAPIContextFields, IAPIContextDispatcher } from 'src/features/core/Intents/ApiContext/dispatcher';
import { IAPIContextFields } from 'src/features/core/Intents/ApiContext/types';
import { intentMatcher } from './builder';
import { executeConditions } from './conditions';
import { propIsNotEmpty } from 'src/utilities/hasValue';
import { StateStore } from '../../ChatEngine/Configs/apiResouces';

interface ContextField {
    'lendsmart_sh/field': string;
    'lendsmart_sh/value'?: string;
    'lendsmart_sh/key_field_value'?: string;
}

interface Rule {
    conditions: any[];
    context: string;
    context_fields: ContextField[];
    mode: string;
}

export class APIContext {
    // A type that has the
    // - JSON: api_context
    // - () => {} dispatch function
    // - string: answe
    // - ApplicationState.d: current reducer data
    //private apiContextRaw: any[];

    // A type array has the
    // - JSON: [api_context]
    private apiResources: StateStore;
    private dispatch: any;
    thisAnswer: any;
    apiContextRaw: any[];


    constructor(data: any) {
        const { apiContexts, thisAnswer, userIntents, currentIntent, apiResources, dispatch } = data;
        this.apiContextRaw = this.findContexts(apiContexts, thisAnswer, userIntents, currentIntent);
        this.apiResources = apiResources;
        this.dispatch = dispatch;
        this.thisAnswer = thisAnswer
    }

    apply() {
        const dispatchers: any = map((item: any) => {
            return this.mkDispatcher(new BaseAPIContextFields(item, this.apiResources, this.thisAnswer))
        }, this.apiContextRaw);

        const services = filter(propIsNotEmpty('kind'), this.runDispatchers(dispatchers))
        return services
    }

    findContexts = (apiContext: any, thisAnswer: any, userIntent: any, currentIntent: any) => {
        const currentContexts = new DispatchContextFinder(userIntent, currentIntent, apiContext, thisAnswer).getCurrentContext();
        return this.mergeContextFields(currentContexts)
    };

    mergeContextFields = (rules: Rule[]): Rule[] => {
        const nonInsertOrDeleteRules: any = filter((rule: Rule) => not(includes(pathOr('', ['mode'], rule), ['insert', 'delete'])), rules);
        const insertOrDeleteRules: Rule[] = filter((rule: Rule) => includes(pathOr('', ['mode'], rule), ['insert', 'delete']), rules);

        const mergedRules: any = pipe(
            //@ts-ignore
            groupBy(prop('context')), // Group rules by 'context'
            map((rulesInContext: any) => {
                return {
                    ...rulesInContext[0], // Take the first rule as the base
                    context_fields: reduce((acc, rule) => equals(pathOr('', ['mode'], rule), 'update')
                        ? concat(acc, pathOr([], ['context_fields'], rule)) // Merge context_fields if has_merge is true
                        : acc, [], rulesInContext) // Otherwise, skip the rule's context_fields
                }
            }),
            values // Convert back to array
            //@ts-ignore
        )(nonInsertOrDeleteRules);

        // Return the insert rules as they are, combined with the merged ones
        return [...insertOrDeleteRules, ...mergedRules];
    };

    mkDispatcher(act: IAPIContextFields) {
        return new APIDispatcher(act, act.getMode(), this.dispatch, '').mkDispatcher();
    }

    runDispatchers(dispatchers: IAPIContextDispatcher[]) {
        return flatten(map((dispatcher: IAPIContextDispatcher) => {
            return [
                dispatcher.rollback(this.dispatch),
                dispatcher.perform(),
                dispatcher.postPerform()
            ]
        }, dispatchers))
    }

}

interface IContextFinder {
    userIntents: any[];
    currentIntent: any;
    apiContexts: any[];
    thisAnswer: string;
}

export class DispatchContextFinder implements IContextFinder {
    userIntents: any[];
    currentIntent: any;
    apiContexts: any[];
    thisAnswer: string;
    constructor(userIntents: any[], currentIntent: any, apiContexts: any[], thisAnswer: string) {
        this.userIntents = userIntents;
        this.apiContexts = apiContexts;
        this.thisAnswer = thisAnswer;
        this.currentIntent = currentIntent;
    }

    getCurrentContext() {
        return this.getMatchedContext(this.userIntents, this.currentIntent, this.apiContexts, this.thisAnswer)
    }
    getMatchedContext = (userIntents: any[], currentIntent: any, apiContexts: any[], thisAnswer: string) => {
        const updIntent = compose(set(lensPath(['answer']), thisAnswer))(currentIntent)
        const result = filter(
            (item: any) => {
                const conditions = pathOr([], ['conditions'], item)
                const applyLogicalCondition = pathOr('', ['apply_condition'], item);
                const result = isEmpty(conditions) ? true : executeConditions(
                    userIntents,
                    conditions,
                    applyLogicalCondition,
                    updIntent,
                    intentMatcher)
                return result;
            },
            apiContexts
        );
        return result;
    }
}

